import React from 'react';
import './Grafiplaten.css';
import fittingImage from '../../../imgs/Grafiplaten.webp'; 

const Grafiplaten = () => {
  return (
    <div className="Grafiplatens-container" data-aos="fade-down-left">
      <img src={fittingImage} alt="Fitting Corrosion" className="Grafiplatens-image" />
    </div>
  );
};

export default Grafiplaten;
